import { render, staticRenderFns } from "./upgrade-madel.vue?vue&type=template&id=cc604e64"
import script from "./upgrade-madel.vue?vue&type=script&lang=ts"
export * from "./upgrade-madel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports